import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import NavigationBar from 'components/Navigation';
import * as S from './WithdrawComplete.styled';
import doneIcon from 'assets/MypageImage/done.png';

function WithdrawComplete() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // 탈퇴 완료 후에는 로그인 페이지로 이동
    navigate('/login');
  };

  return (
    <S.Body>
      <S.Header>
        <S.BackButton onClick={handleGoBack}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </S.BackButton>
        회원탈퇴
      </S.Header>

      <S.ContentWrap>
        <S.IconContainer>
          <S.DoneIcon src={doneIcon} alt="완료" />
        </S.IconContainer>

        <S.Message>회원탈퇴가 완료되었습니다.</S.Message>
      </S.ContentWrap>

      <NavigationBar />
    </S.Body>
  );
}

export default WithdrawComplete;
